import { render } from "./AlbumMaster.vue?vue&type=template&id=1c581971&scoped=true"
import script from "./AlbumMaster.vue?vue&type=script&lang=js"
export * from "./AlbumMaster.vue?vue&type=script&lang=js"

import "./AlbumMaster.vue?vue&type=style&index=0&id=1c581971&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\MSRTC\\MSRTC-CODE\\ui-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c581971"]])

export default __exports__